import { Component, OnInit } from '@angular/core';
import { GridviewComponent } from '../gridview/gridview.component';
import { ProgressbarComponent } from '../progressbar/progressbar.component';
import { DeleteComponent } from '../delete/delete.component';
import {FormBuilder, ReactiveFormsModule, FormsModule, NgControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import { HttpEventType,HttpResponse,HttpRequest } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';
import { Router,RouterModule} from '@angular/router';
import * as $ from 'jquery';

 
@Component({
  selector: 'app-informalworkfare',
  templateUrl: './informalworkfare.component.html',
  styleUrls: ['./informalworkfare.component.css']
})
export class InformalworkfareComponent implements OnInit {
  fileToUpload: File = null;
  filestoUpload=[];
  addNew:Boolean = false;
  private gridApi;
  private gridColumnApi;
  private summarygridApi;
  private summarygridColumnApi;
  public context;
  private workfare={
    name:null,
    desc:null,
    address:null,
    month:null,
    supPhn:null,
    supMail:null,
    supName:null,
    orgFax:null,
    orgMailing:null,
    orgPhn:null,
    repHours:null,
    activity:null,
    id:null,
    workfare_id:null,
    path:[],
    perId:null,
    fin_sw:null
  }
  monthDropdown:any=[];
  reportedHours:any;
  reportedMins:any;
  activityReason:any;
  error:Boolean = true;
  selectedMonth:any;
  viewOnly:Boolean = false;
  assignedHours:Number;
  monthError:Boolean = false;
  hoursArray = new Array();
  maxHours:Boolean = false;
  public frameworkComponents;
  public uploadframeworkComponents;
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  columnDefs = [
    {headerName: 'Organization Name', field: 'org_name' },
    {headerName: 'Month', field: 'month' },
    {headerName: 'Reported Hours', field: 'reported_hours'},
    {headerName: 'Verified Hours', field: 'verfied_hours'},
    {headerName: 'Action', field: 'id',cellRenderer:'viewrenderer'}
];
uploadcolumnDefs =[
  {headerName: 'File Name', field: 'originalname' },
  {headerName: 'Date', field: 'date' },
  {headerName: 'Size', field: 'size' },
  {headerName: 'Progress', field: 'progress',cellRenderer:'progressrenderer' },
  {headerName: 'Action', field: 'path',cellRenderer:'viewrenderer'}
];
uploadData =[];

rowData = [];
  constructor(public toastService:ToastrService, public loginService:LoginService, public http:HttpClient, public router:Router) {
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    if(sessionStorage.getItem('workfare') !== undefined && CryptoJS.AES.decrypt(sessionStorage.getItem('workfare'), key).toString(CryptoJS.enc.Utf8) !== 'true'){
      this.router.navigate(['dashboard']);
    }
   }

  ngOnInit() {
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    this.workfare.perId = this.loginService.personId;
    this.context = {
      componentParent:this
    };
    this.frameworkComponents = {
      viewrenderer: GridviewComponent
    };
    for(let i=0; i<81; i++){
      this.hoursArray.push(i);
    };
    this.uploadframeworkComponents = {
      viewrenderer: DeleteComponent,
      progressrenderer:ProgressbarComponent
    };
    let monthName = new Array("January","February","March","April","May","June","July","August","September","October","November","December");
    let d = new Date();
    for(let i=0;i<=24;i++){
      this.monthDropdown.push(monthName[d.getMonth()]+' '+d.getFullYear());
      d.setMonth(d.getMonth()-1);
    }
    this.selectedMonth = this.monthDropdown[0];
    this.loadSummary();
    this.assignedHours = Math.floor(Number(CryptoJS.AES.decrypt(sessionStorage.getItem('benefit'), key).toString(CryptoJS.enc.Utf8))/Number(CryptoJS.AES.decrypt(sessionStorage.getItem('maxwage'), key).toString(CryptoJS.enc.Utf8)));
  }
  onsummaryGridReady(params){
    this.summarygridApi = params.api;
    this.summarygridColumnApi = params.columnApi;
    this.summarygridApi.sizeColumnsToFit();
    //this.summarygridApi.setDomLayout("autoHeight");
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  }
  newWorkfare(){
    this.addNew = true;
      this.workfare = {
        name:null,
        desc:null,
        address:null,
        month:null,
        supPhn:null,
        supMail:null,
        supName:null,
        orgFax:null,
        orgMailing:null,
        orgPhn:null,
        repHours:null,
        activity:null,
        id:null,
        workfare_id:null,
        path:[],
        perId:null,
        fin_sw:null
      };
      this.workfare.perId = this.loginService.personId;
      this.fileToUpload = null;
      this.filestoUpload=[];
      this.reportedHours = null;
  this.reportedMins = null;
  this.activityReason = null;
  this.uploadData =[];
  }
  validate(){
    if(this.workfare.month != null || this.workfare.month != undefined){
      if(parseInt(this.workfare.month.substring(0, 2)) > 12){
        this.workfare.month = null;
        this.error = false;
      }
      else if(parseInt(this.workfare.month.substring(0, 2)) > (new Date().getMonth()+1) && (parseInt(this.workfare.month.substring(2, 6)) >= new Date().getFullYear())){
        this.workfare.month = null;
        this.error = false;
      }
      else if(parseInt(this.workfare.month.substring(0, 2)) <= (new Date().getMonth()+1) && (parseInt(this.workfare.month.substring(2, 6)) > new Date().getFullYear())){
        this.workfare.month = null;
        this.error = false;
      }
      else{
        let request = {
          month:this.workfare.month.substring(0,2)+ '/'+ this.workfare.month.substring(2,6),
          perId: this.loginService.personId
        }
        this.loginService.loadworkfare(request).subscribe((data)=>{
          let result = CryptoJS.AES.decrypt(data["result"],"workfare").toString(CryptoJS.enc.Utf8);
          let convResult = JSON.parse(result);
          if(convResult.length > 0){
            if(convResult[0].fin_sw == 'Y'){
              this.monthError = true;
              this.workfare.month = null;
            }
            else{
              this.monthError = false;
            }
          }
          else{
            this.monthError = false;
          }
        },error=>{
          this.toastService.error("Unable to validate workfare","Volunteer");
        })
      }
    }
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    if(((this.fileToUpload.size/1024)/1024) > 5){
      this.toastService.error("File size exceeds maximum limit","Volunteer");
    }
    else if(this.fileToUpload.type === 'application/pdf' || this.fileToUpload.type === 'image/jpeg' || this.fileToUpload.type === 'image/png'){
      this.filestoUpload.push(this.fileToUpload);
      let file={
        originalname:this.fileToUpload.name,
        date:(new Date().getMonth()+1) + '/'+new Date().getDate() + '/' + new Date().getFullYear(),
        size:((this.fileToUpload.size/1024)/1024).toFixed(2)+'MB',
        progress:0,
        path:"upload"
      }
      this.uploadData.push(file);
      this.gridApi.setRowData(this.uploadData);
    }
    else{
      this.toastService.error("File type is not supported to upload","Volunteer");
    }
}
upload(){
  let formData = new FormData();
  if(this.filestoUpload.length == 0){
    this.toastService.error("No files selected to upload", "Volunteer");
  }
  else{
    for(let i =0; i < this.filestoUpload.length; i++){
      formData.append("files", this.filestoUpload[i], this.filestoUpload[i]['name']);
    }
    const req = new HttpRequest('POST', this.loginService.serverConst+ '/fileUpload', formData, {
      reportProgress: true,
    });
    this.http.request(req).subscribe(event => {
      // Via this API, you get access to the raw event stream.
      // Look for upload progress events.
      if (event.type === HttpEventType.UploadProgress) {
        // This is an upload progress event. Compute and show the % done:
        const percentDone = Math.round(100 * event.loaded / event.total);
        this.uploadData.forEach((element)=>{
          element.progress = percentDone;
        })
        this.gridApi.setRowData(this.uploadData);
      } else if (event instanceof HttpResponse) {
        this.filestoUpload = [];
        event.body["data"].forEach((element)=>{
          this.uploadData.forEach((element2)=>{
            if((element.originalname == element2.originalname)&& (element2.size == (((element.size/1024)/1024).toFixed(2)+'MB'))){
              element2.path =element.filename;
            }
          })
        })
        this.workfare.path.forEach((element)=>{
          delete element.destination;
          delete element.encoding;
          delete element.fieldname;
          delete element.filename;
          delete element.mimetype;
          element.date = (new Date().getMonth()+1) + '/'+new Date().getDate() + '/' + new Date().getFullYear();
        });
        this.gridApi.setRowData(this.uploadData);
        this.workfare.path = this.uploadData;
        this.saveDocument();
      }
    },error=>{
      this.toastService.error("Unable to upload file", "Volunteer");
    });
  }
}
save(){
  this.workfare.repHours = parseFloat(this.reportedHours+'.'+this.reportedMins).toFixed(2);
  if(this.workfare.repHours > 80){
    this.maxHours = true;
  }
  else{
    this.saverecord();
  }
}
saverecord(){
  this.workfare.repHours = parseFloat(this.reportedHours+'.'+this.reportedMins).toFixed(2);
  this.workfare.activity = this.activityReason;
  this.workfare.fin_sw = 'N';
  if(this.filestoUpload.length > 0){
    this.upload();
  }
  let request = {
    details:CryptoJS.AES.encrypt(JSON.stringify(this.workfare),"workfare").toString()
  }
  this.loginService.saveworkfare(request).subscribe((data)=>{
    if(data["message"]== "success"){
      this.toastService.success("Successfully saved workfare","Volunteer");
      this.addNew = false;
      this.loadSummary();
    }
    else{
      this.toastService.error("Record not saved: Please review or contact Help Desk","Volunteer");
    }
  },error=>{
    this.toastService.error("Record not saved: Please review or contact Help Desk","Volunteer");
  })
}
clickEvent(event){
  if(event.column.colDef.headerName == 'Action' && event.data.defaultAction == 'delete' && event.data.path == 'upload'){
    this.uploadData.splice(event.node.rowIndex,1);
    this.gridApi.setRowData(this.uploadData);
    this.filestoUpload = this.filestoUpload.filter(function( obj ) {
      return ((obj.name !== event.data.name) && (((obj.size/1024)/1024).toFixed(2)+'MB' != event.data.size));
    });
  }
  else if(event.column.colDef.headerName == 'Action' && event.data.defaultAction == 'delete'){
    this.uploadData.splice(event.node.rowIndex,1);
    this.gridApi.setRowData(this.uploadData);
    this.workfare.path = this.workfare.path.filter(function( obj ) {
      return ((obj.originalname != event.data.originalname) && (obj.size != event.data.size));
    });
  }
}
loadSummary(){
  this.viewOnly = false;
  let monthName = new Array("January","February","March","April","May","June","July","August","September","October","November","December");
  let splitValue = this.selectedMonth.split(' ');
  let request = {
    month:(monthName.indexOf(splitValue[0])+1) +'/'+ splitValue[1],
    perId: this.loginService.personId
  }
  if(request.month.length == 6){
    request.month = 0+request.month;
  }
  this.loginService.loadworkfare(request).subscribe((data)=>{
    let result = CryptoJS.AES.decrypt(data["result"],"workfare").toString(CryptoJS.enc.Utf8);
    let convResult = JSON.parse(result);
    this.rowData = convResult;
    this.addNew = false;
    let count = 0;
    this.rowData.forEach((element)=>{
      if(element.fin_sw == 'Y'){
        count = count+1;
      }
    });
    if(count != 0 && count == this.rowData.length){
      this.viewOnly = true;
    }
  },error=>{
    this.toastService.error("Unable to load workfare","Volunteer");
  })
}
summaryclickEvent(event){
  if(event.column.colDef.headerName == 'Action' && event.data.defaultAction == 'view'){
    this.addNew = true;
    this.maxHours = false;
    this.monthError = false;
    this.error = true;
    this.loginService.getworkfare(event.data.id).subscribe((data)=>{
      let result = CryptoJS.AES.decrypt(data["result"],"workfare").toString(CryptoJS.enc.Utf8);
      let convResult = JSON.parse(result);
      this.workfare.name = convResult.org_name;
      this.workfare.desc = convResult.org_desc;
      this.workfare.address = convResult.org_st_address;
      this.workfare.month = convResult.month;
      this.workfare.supPhn = convResult.sup_contact;
      this.workfare.supMail = convResult.sup_email;
      this.workfare.supName = convResult.sup_name;
      this.workfare.orgFax = convResult.org_fax;
      this.workfare.orgMailing = convResult.org_mailing;
      this.workfare.orgPhn = convResult.org_contact;
      this.activityReason = convResult.activity;
      this.workfare.id = convResult.id;
      this.workfare.workfare_id = convResult.workfare_id;
      this.uploadData = JSON.parse(convResult.path);
      this.uploadData.forEach((element)=>{
        if(!isNaN(element.size)){
          element.size = ((element.size/1024)/1024).toFixed(2)+"MB";
        }
        element.progress = 100;
        element.switch = convResult.fin_sw;
      });
      this.workfare.path = this.uploadData;
      convResult.reported_hours = parseFloat(convResult.reported_hours).toFixed(2);
      this.reportedHours = convResult.reported_hours.toString().split('.')[0];
      this.reportedMins = convResult.reported_hours.toString().split('.')[1];
    },error=>{
      this.toastService.error("Unable to load workfare","Volunteer");
    })
  }
}
finalize(){
  let monthName = new Array("January","February","March","April","May","June","July","August","September","October","November","December");
  let splitValue = this.selectedMonth.split(' ');
  let request = {
    month:(monthName.indexOf(splitValue[0])+1) +'/'+ splitValue[1],
    perId: this.loginService.personId,
    dueDt:this.loginService.staticData.get("TASKDUEDATES").find(obj => obj.value == 'CW').name
  }
  if(request.month.length == 6){
    request.month = 0+request.month;
  }
  this.loginService.finalize(request).subscribe((data)=>{
    $("#closeConfirm").click();
    if(data["message"]=='success'){
      this.toastService.success("Successfully finalized your hours","Volunteer");
      this.viewOnly = true;
      this.rowData.forEach((element)=>{
        element.fin_sw = 'Y';
      })
    }
    else{
      this.toastService.error("Record not saved: Please review or contact Help Desk","Volunteer");
    }
  },error=>{
    this.toastService.error("Record not saved: Please review or contact Help Desk","Volunteer");
  })
}
saveDocument(){
  this.uploadData.forEach((element)=>{
    let request = {
      name:element.originalname,
      uploaded_dt:element.date,
      size:element.size,
      progress:element.progress,
      doc_type:'Comparable Workfare',
      uploaded_by:this.loginService.firstName + ' ' + this.loginService.lastName,
      person_id:this.loginService.personId,
      path:element.path
    }
    this.loginService.saveDocuments(request).subscribe((data)=>{
      if(data["message"] == 'success'){
        this.toastService.success("Succesfully uploaded file","Volunteer");
      }
      else{
        this.toastService.success("Unable to Upload file","Volunteer");
      }
    },error=>{
      this.toastService.success("Unable to Upload file","Volunteer");
    })
  });
}
focus1(event){
  if(event.keyCode == 9){
    this.gridApi.ensureIndexVisible(0);
    let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
      return;
    }
    else{
      event.preventDefault();
      this.gridApi.setFocusedCell(0, firstCol);
    }
  }
  else{
    return;
  }
}
focus(event){
  if(event.keyCode == 9){
    this.summarygridApi.ensureIndexVisible(0);
    let firstCol = this.summarygridColumnApi.getAllDisplayedColumns()[0];
    this.summarygridApi.ensureColumnVisible(firstCol);
    if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
      return;
    }
    else{
      event.preventDefault();
      this.summarygridApi.setFocusedCell(0, firstCol);
    }
  }
  else{
    return;
  }
}
}



// WEBPACK FOOTER //
// ./src/app/informalworkfare/informalworkfare.component.ts